// Перевірка доступності всієї категорії в ролі
export const getCategoryAccessCategory = ({ path, permissions, categoryName }) => {
    try {
        // console.log('path', path)
        // console.log('permissions', permissions)
        // console.log('categoryName1', categoryName)

        if (path === '/') {
            return true
        }
        
        let access = false
        const splitPath = path ? path.split('/') : null // Розбиваємо шлях по елементам
        const splitPathClear = splitPath ? splitPath.filter(el => el !== '') : [] // Прибираємо порожні значення

        if (permissions && permissions.length > 0) {
            for (const permission of permissions) {
                if (categoryName) { // Якщо вказана точна категорія, то по ній
                    const categoryPermission = '/' + permission.category // Тут додаю "/", так як в меню вказано слеш в полі
                    // console.log('categoryName', categoryName)
                    // console.log('categoryPermission', categoryPermission)
                    if (categoryName === categoryPermission) {
                        access = true
                    }
                } else if (permission.category === splitPathClear[0]) { // ЯЧкщо не вказана точна категорія, то по шляху
                    // console.log('permission.category', permission.category)
                    // console.log('splitPathClear[0]', splitPathClear[0])
                    access = true
                }
            }
        }

        return access
    } catch (e) {

    }
}

// Отримуємо перше доступне посилання в категорії (треба для меню)
export const getFirstAccessPathInCategory = ({ permissions, categoryName }) => {
    try {        
        let firstPath = ''

        if (permissions && permissions.length > 0) {
            for (const permission of permissions) {
                // Якщо категорія співпадає з категорією в доступах, то беремо першу доступну
                const categoryFind = '/' + permission.category
                if (!firstPath && categoryName === categoryFind) {
                    firstPath = '/' + permission.path // Тут додаю "/", так як в меню вказано слеш в полі
                }
            }
        }

        return firstPath
    } catch (e) {

    }
}

// Перевірка доступності підкатегорії в категорії в ролі (верхнє меню)
export const getCategoryAccessSubCategory = ({ path, permissions, categoryName, subCategoryName }) => {
    try {        
        let access = false
        const splitPath = path ? path.split('/') : null // Розбиваємо шлях по елементам
        const splitPathClear = splitPath ? splitPath.filter(el => el !== '') : [] // Прибираємо порожні значення

        if (permissions && permissions.length > 0) {
            for (const permission of permissions) {
                let accessCategory = false

                // Перевірка категорії
                if (categoryName) { // Якщо вказана точна категорія, то по ній
                    const categoryPermission = '/' + permission.category // Тут додаю "/", так як в меню вказано слеш в полі
                    if (categoryName === categoryPermission) {
                        accessCategory = true
                    }
                } else if (permission.category === splitPathClear[0]) { // Якщо не вказана точна підкатегорія, то по шляху
                    accessCategory = true
                }

                // Перевірка підкатегорії
                if (accessCategory) { // Якщо доступна категорія, то перевіряємо підкатегорію
                    if (subCategoryName) { // Якщо вказана точна категорія, то по ній
                        const subCategoryPermission = '/' + splitPathClear[1] // Тут додаю "/", так як в меню вказано слеш в полі
                        if (subCategoryName === subCategoryPermission) {
                            access = true
                        }
                    } else if (permission.path === splitPathClear[1]) { // Якщо не вказана точна підкатегорія, то по шляху
                        access = true
                    }
                }
            }

        }

        return access
    } catch (e) {

    }
}

// Перевірка доступності сторінки по шляху
export const getAccessPage = ({ path, permissions }) => {
    try {
        let access = false

        // console.log('path', path)
        // const splitPath = path ? path.split('/') : null // Розбиваємо шлях по елементам
        // const splitPathClear = splitPath ? splitPath.filter(el => el !== '') : [] // Прибираємо порожні значення

        if (path === '/') { // Якщо головна
            return true
        }

        if (permissions && permissions.length > 0) {
            for (const permission of permissions) {
                // let pagePath = splitPathClear[0] + '/' + splitPathClear[1]
                let pagePath = permission.category + '/' + permission.path
                if (path.includes(pagePath)) {
                    access = true
                }
            }

        }

        return access
    } catch (e) {

    }
}

export const getUserName = ({ user }) => {
    try {
        let name = ''

        if (user) {
            if (user.name) {
                name = user.name
            }
            if (user.surname) {
                name += ' ' + user.surname
            }
        }

        return name
    } catch (e) {

    }
}